export function cloneRegExp(value: RegExp): RegExp {
  const cloned = new (value as any).constructor(
    value.source,
    value.flags,
  ) as RegExp;

  cloned.lastIndex = value.lastIndex;

  return cloned;
}
